import React from 'react';
import type { Step } from 'react-joyride';

import Mp4GifEmulator from 'components/common/ui/Mp4GifEmulator';

import mp4 from 'assets/videos/guestlist/walkthroughCustomize.mp4';

import styles from '../ManageAddressCollectionLinkTour.module.less';

const Step3Component: React.FC = () => (
  <div>
    <p className={styles.stepCopy}>
      Edit your magic link anytime. We&apos;ll work our magic to make sure guests see the most
      updated version without changing the URL.
    </p>
    <Mp4GifEmulator src={mp4} className={styles.gif} />
  </div>
);

const Step3: Step = {
  target: '.guest-collection__edit-link',
  content: <Step3Component />,
  placement: 'right',
  disableBeacon: true,
};

export default Step3;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ManageAddressCollectionLinkTour/Steps/Step3.tsx